module.exports = __webpack_public_path__ + "static/media/addHorizontalWorkplaneInRoom.edd55634.gif";